<script setup>

</script>

<template>
  <footer class="footer flex w-full justify-center items-center text-center pt-5">
    <span class="grid place-items-center text-zinc-700 responsive-body-xsmall">
      <span>&copy; 2025 The Fashion Project</span>
      <span>
        Designed and Developed by
        <span class="text-[#2a285e]">Existanze</span>-<span class="text-[#9acc70]">#connectingdots</span>
      </span>
    </span>
  </footer>
</template>

<style scoped>

</style>